import { createGlobalStyle } from 'styled-components';
import type { ThemeConfig } from 'antd/es/config-provider/context';
import type {
  AliasToken,
  OverrideToken,
  MappingAlgorithm,
} from 'antd/es/theme/interface';
import { WSB_MERCHANT_SOURCE } from '../constants/merchant';

type ComponentsConfig = {
  [key in keyof OverrideToken]?: OverrideToken[key] & {
    algorithm?: boolean | MappingAlgorithm | MappingAlgorithm[];
  };
};

export const GlobalStyle = createGlobalStyle``;

export const antdShoreThemeToken: Partial<AliasToken> = {
  // SeedToken
  sizeStep: 4,
  sizeUnit: 4,
  borderRadius: 4,
  zIndexBase: 0,
  colorBgLayout: '#f8f8f8',
  colorBgBase: '#ffffff',
  colorError: '#ff2e52',
  colorInfo: '#00d0be',
  colorLink: '#00d0be',
  colorPrimary: '#00d0be',
  colorPrimaryText: '#00d0be',
  colorTextSecondary: '#64748B',
  colorBorderSecondary: '#ededed',
  colorText: '#0F172A',
  colorTextBase: '#0F172A',
  colorWarning: '#faad14',
  controlHeight: 32,
  fontFamily: '"Nunito Sans","Open Sans",Arial,sans-serif',
  fontSize: 14,
  lineHeight: 1.42,
  fontSizeHeading1: 38,
  fontSizeHeading2: 30,
  fontSizeHeading3: 24,
  fontSizeHeading4: 20,
  fontSizeHeading5: 16,
  fontSizeLG: 16,
  fontSizeSM: 12,
  fontSizeXL: 20,
  fontWeightStrong: 600,

  // AliasToken
  colorTextLightSolid: '#ffffff',

  sizeXXL: 48,
  sizeXL: 32,
  sizeLG: 24,
  sizeMD: 20,
  sizeMS: 16,
  size: 16,
  sizeSM: 12,
  sizeXS: 8,
  sizeXXS: 4,
  padding: 16,
  paddingMD: 20,
  paddingSM: 12,
  paddingXS: 8,
  paddingXXS: 4,
  paddingLG: 24,
  paddingXL: 32,
  margin: 16,
  marginSM: 12,
  marginXS: 8,
  marginXXS: 4,
  marginLG: 24,
  marginXL: 32,
  marginXXL: 48,
};

export const antdOneDotComThemeToken: Partial<AliasToken> = {
  // ...antdShoreThemeToken,
  colorText: '#141414',
  colorTextBase: '#141414',
  colorError: '#b30016',
  colorWarning: '#a35700',
  colorSuccess: '#467412',
  colorLink: '#0066aa',
  wireframe: false,
  colorPrimary: '#0078c8',
  colorInfo: '#0078c8',
  colorBgBase: '#ffffff',
  fontFamily: '"Plus Jakarta Sans","Nunito Sans","Open Sans",Arial,sans-serif',
};

export const antdShoreThemeComponents: ComponentsConfig = {
  Layout: {
    headerBg: '#f2f2f2',
  },
};

export const antdOneDotComThemeComponents: ComponentsConfig = {
  Layout: {
    headerBg: '#f2f2f2',
  },
};

export const antdShoreTheme: ThemeConfig = {
  token: antdShoreThemeToken,
  components: antdShoreThemeComponents,
};

export const AntdOneDotComTheme: ThemeConfig = {
  token: antdOneDotComThemeToken,
  components: antdOneDotComThemeComponents,
};

export const getAntdTheme = ({
  merchantId,
  merchantSource,
}: {
  merchantId?: string;
  merchantSource?: string;
}): ThemeConfig => {
  const themeConfig =
    merchantId && merchantSource === WSB_MERCHANT_SOURCE
      ? AntdOneDotComTheme
      : antdShoreTheme;

  return themeConfig;
};
